export function headerAnimation() {
  let mainPageBaner = document.getElementsByClassName("logo-sentence");

  if (!mainPageBaner || mainPageBaner.length == 0) return;

  mainPageBaner = mainPageBaner[0];
  let mainPageBaner_morphElement =
    mainPageBaner.getElementsByClassName("morph-sentences");
  if (!mainPageBaner_morphElement || mainPageBaner_morphElement.length == 0)
    return;

  let sentences = mainPageBaner_morphElement[0].getAttribute("data-sentences");
  if (!sentences || sentences == "") return;

  const texts = sentences.split(",");

  if (document.body.classList.contains("no-morph-browser")) {
    changeText(texts);
  } else {
    changeText(texts);
    //morphInit(texts);
  }
}

function changeText(texts) {
  let timer = false;
  const animationTime = 500;
  const waitTime = 1500;
  const showInClass = "animationIn";
  const showOutClass = "animationOut";
  const hiddenClass = "hidden";

  let showingIndex = 0;
  let txtIndex = 0;

  const elts = [
    document.getElementById("text1"),
    document.getElementById("text2"),
  ];

  elts[1].classList.add(showOutClass);

  elts[0].textContent = texts[txtIndex];
  elts[1].textContent = texts[txtIndex + 1];

  function doAnimation() {
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      let nextTxtIndex = txtIndex + 1 >= texts.length ? 0 : txtIndex + 1;
      let nextShowingIndex =
        showingIndex + 1 >= elts.length ? 0 : showingIndex + 1;

      elts[nextShowingIndex].textContent = texts[nextTxtIndex];

      elts[showingIndex].classList.remove(showInClass);
      elts[showingIndex].classList.add(showOutClass);
      elts[nextShowingIndex].classList.remove(showOutClass);
      elts[nextShowingIndex].classList.add(showInClass);

      showingIndex = nextShowingIndex;
      txtIndex = nextTxtIndex;

      doAnimation();
    }, animationTime + waitTime);
  }

  doAnimation();
}

function morphInit(texts) {
  const elts = {
    text1: document.getElementById("text1"),
    text2: document.getElementById("text2"),
  };

  //const texts = ["Stać Cię na to", "Planujemy", "Realizujemy"];

  const morphTime = 1;
  const cooldownTime = 0.5;

  let textIndex = texts.length - 1;
  let time = new Date();
  let morph = 0;
  let cooldown = cooldownTime;

  elts.text1.textContent = texts[textIndex % texts.length];
  elts.text2.textContent = texts[(textIndex + 1) % texts.length];

  function doMorph() {
    morph -= cooldown;
    cooldown = 0;

    let fraction = morph / morphTime;

    if (fraction > 1) {
      cooldown = cooldownTime;
      fraction = 1;
    }

    setMorph(fraction);
  }

  function setMorph(fraction) {
    elts.text2.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
    elts.text2.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

    fraction = 1 - fraction;
    elts.text1.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
    elts.text1.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

    elts.text1.textContent = texts[textIndex % texts.length];
    elts.text2.textContent = texts[(textIndex + 1) % texts.length];
  }

  function doCooldown() {
    morph = 0;

    elts.text2.style.filter = "";
    elts.text2.style.opacity = "100%";

    elts.text1.style.filter = "";
    elts.text1.style.opacity = "0%";
  }

  function animate() {
    requestAnimationFrame(animate);

    let newTime = new Date();
    let shouldIncrementIndex = cooldown > 0;
    let dt = (newTime - time) / 1000;
    time = newTime;

    cooldown -= dt;

    if (cooldown <= 0) {
      if (shouldIncrementIndex) {
        textIndex++;
      }

      doMorph();
    } else {
      doCooldown();
    }
  }

  animate();
}
